module.exports = __webpack_public_path__ + "static/media/coming-soon.793a1ca3.svg";